import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg';
const ProductNonFilledIcon = (props) => (
  <Svg
    width={props.width}
    height={props.height}
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_7621_1741)">
      <Path
        d="M6 8.68752C6 9.92399 4.768 10.9185 3.25 10.9185C2.48894 10.9185 1.80247 10.6679 1.30506 10.2674C0.808 9.86281 0.5 9.30387 0.5 8.68787L6 8.68752ZM6 8.68752C6 9.30352 6.308 9.86281 6.80506 10.2674C7.30212 10.6679 7.98859 10.9185 8.75 10.9185C10.268 10.9185 11.5 9.92399 11.5 8.68752M6 8.68752H11.5M11.5 8.68752C11.5 9.30352 11.808 9.86281 12.3051 10.2674C12.8021 10.6679 13.4886 10.9185 14.25 10.9185C15.768 10.9185 17 9.92399 17 8.68752M11.5 8.68752H17M17 8.68752C17 9.30352 17.308 9.86281 17.8051 10.2674C18.3021 10.6679 18.9886 10.9185 19.75 10.9185C21.268 10.9185 22.5 9.92399 22.5 8.68752H17ZM9.41 15.0369V21.0165H13.59V15.0369H9.41ZM19.75 12.2385C18.6895 12.2385 17.726 11.8865 17 11.3055C16.274 11.8865 15.3105 12.2385 14.25 12.2385C13.1895 12.2385 12.226 11.8865 11.5 11.3055C10.774 11.8865 9.81047 12.2385 8.75 12.2385C7.68953 12.2385 6.726 11.8865 6 11.3055C5.274 11.8865 4.31047 12.2385 3.25 12.2385C3.03447 12.2385 2.82306 12.2254 2.61647 12.1945V20.3565C2.61647 20.7215 2.91141 21.0165 3.27647 21.0165H8.09V15.0369C8.09 14.3065 8.684 13.7169 9.41 13.7169H13.59C14.316 13.7169 14.91 14.3065 14.91 15.0369V21.0165H19.7235C20.0886 21.0165 20.3835 20.7215 20.3835 20.3565V12.19C20.1769 12.2254 19.9655 12.2385 19.75 12.2385ZM18.8215 1.34846C18.7115 1.12846 18.4826 0.983398 18.232 0.983398H4.768C4.51706 0.983398 4.28847 1.12846 4.17847 1.34846L1.16 7.36787H21.84L18.8215 1.34846Z"
        stroke={props.color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_7621_1741">
        <Rect width={22} height={22} fill="white" transform="translate(0.5)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default ProductNonFilledIcon;
